import { TimestampFormatProvider } from "@/shared/components/RobotoMarkdown/timeFormat";

import { AgentThreadFullscreenModal } from "./AgentThreadFullscreenModal";
import styles from "./AgentThreadSidebar.module.css";
import { AgentThreadSidebarControls } from "./AgentThreadSidebarControls";
import { AgentThreadSidebarMainContent } from "./AgentThreadSidebarMainContent";
import {
  AIAgentThreadProvider,
  useAIAgentThread,
} from "./AIAgentThreadContext";

interface AgentThreadSidebarProps {
  onClose: () => void;
}

const AgentThreadSidebarContent = ({ onClose }: AgentThreadSidebarProps) => {
  const { isFullscreen } = useAIAgentThread();

  return (
    <>
      <AgentThreadFullscreenModal open={isFullscreen} onClose={onClose} />
      <div className={styles.container}>
        <AgentThreadSidebarControls onClose={onClose} />
        <AgentThreadSidebarMainContent />
      </div>
    </>
  );
};

export const AgentThreadSidebar = ({ onClose }: AgentThreadSidebarProps) => {
  return (
    <AIAgentThreadProvider>
      {/*
       * Static `storageKey` is intentional: the timestamp-format preference is
       * global across all thread sessions, not per-session. Switching threads keeps
       * the user's chosen format.
       */}
      <TimestampFormatProvider storageKey="roboto-ai-agent-thread-time-format">
        <AgentThreadSidebarContent onClose={onClose} />
      </TimestampFormatProvider>
    </AIAgentThreadProvider>
  );
};
